import { useEffect, useRef } from "react";
import backDots from "../../media/img/back-dots.png"
import backDotsTwo from "../../media/img/back-dots-two.png"
import messageOne from "../../media/svg/message-one.svg";
import messageTwo from "../../media/svg/message-two.svg";
import messageThree from "../../media/svg/message-three.svg";
import messageFour from "../../media/svg/message-four.svg";
import circleBlueGreen from "../../media/img/circle-blue-green.png";
import circleOrangePurple from "../../media/img/circle-orange-purple.png";
import circleOrangePurpleTwo from "../../media/img/circle-orange-purple-two.png";
import ringOpacity from "../../media/img/ring-opacity.png";
import Anio2026Text from "../../media/img/2026-text.png";
import shieldPerson from "../../media/svg/shield-person.svg";
import balanceIcon from "../../media/svg/balance-icon.svg";
import fingerprintLap from "../../media/svg/fingerprint-lap.svg";
import fingerprintCell from "../../media/svg/fingerprint-cell.svg";

export default function HeroParallax(): JSX.Element {
  const parallaxRef = useRef<HTMLImageElement[]>([]);
  

  useEffect(() => {
    let animationFrameId: number | null = null;

    const parallaxScroll = (): void => {
      const scrollTop = window.scrollY;

      parallaxRef.current.forEach((element) => {
        if (!element) return;

        const speed = parseFloat(element.dataset.speed || "0");

        element.style.transform = `
          translate3d(
            0,
            ${scrollTop * speed}px,
            0
          )
        `;
      });
    };

    const handleScroll = (): void => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = requestAnimationFrame(parallaxScroll);
    };

    window.addEventListener("scroll", handleScroll);

    parallaxScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  const addToRefs = (element: HTMLImageElement | null): void => {
    if (element && !parallaxRef.current.includes(element)) {
      parallaxRef.current.push(element);
    }
  };

  return (
    <section className="hero-section">
      <img
        ref={addToRefs}
        src={backDots}
        alt=""
        id="dots-back-top"
        className="parallax-scroll"
        data-speed="-0.08"
      />

      <img
        ref={addToRefs}
        src={backDotsTwo}
        alt=""
        id="dots-back-bottom"
        className="parallax-scroll"
        data-speed="-0.1"
      />

      <img
        ref={addToRefs}
        src={backDotsTwo}
        alt=""
        id="dots-back-middle"
        className="parallax-scroll"
        data-speed="-0.2"
      />

      <img
        ref={addToRefs}
        src={messageOne}
        alt="mensaje uno"
        id="message-one"
        className="parallax-scroll"
        data-speed="0.18"
      />

      <img
        ref={addToRefs}
        src={messageTwo}
        alt="mensaje dos"
        id="message-two"
        className="parallax-scroll"
        data-speed="0.28"
      />

      <img
        ref={addToRefs}
        src={messageThree}
        alt="mensaje tres"
        id="message-three"
        className="parallax-scroll"
        data-speed="0.12"
      />

      <img
        ref={addToRefs}
        src={messageFour}
        alt="mensaje cuatro"
        id="message-four"
        className="parallax-scroll"
        data-speed="-0.15"
      />

      <img
        ref={addToRefs}
        src={circleBlueGreen}
        alt=""
        id="circle-blue-green"
        className="img-back-main parallax-scroll"
        data-speed="0.10"
      />

      <img
        ref={addToRefs}
        src={circleOrangePurple}
        alt=""
        id="circle-orange-purple"
        className="img-back-main parallax-scroll"
        data-speed="-0.12"
      />

      <img
        ref={addToRefs}
        src={circleOrangePurpleTwo}
        alt=""
        id="circle-orange-purple-two"
        className="img-back-main parallax-scroll"
        data-speed="-0.20"
      />

      <img
        ref={addToRefs}
        src={ringOpacity}
        alt=""
        id="ring-opacity"
        className="img-back-main parallax-scroll"
        data-speed="0.08"
      />

      <img
        ref={addToRefs}
        src={Anio2026Text}
        alt=""
        id="anio-text"
        className="img-back-main parallax-scroll"
        data-speed="-0.08"
      />

      <img
        ref={addToRefs}
        src={shieldPerson}
        alt=""
        id="shield-person"
        className="icon-white-fig parallax-scroll"
        data-speed="-0.01"
      />

      <img
        ref={addToRefs}
        src={balanceIcon}
        alt=""
        id="balance-icon"
        className="icon-white-fig parallax-scroll"
        data-speed="-0.18"
      />

      <img
        ref={addToRefs}
        src={fingerprintLap}
        alt=""
        id="fingerprint-lap"
        className="icon-white-fig parallax-scroll"
        data-speed="0.12"
      />

      <img
        ref={addToRefs}
        src={fingerprintCell}
        alt=""
        id="fingerprint-cell"
        className="icon-white-fig parallax-scroll"
        data-speed="-0.2"
      />
    </section>
  );
}